import { defineComponent as _defineComponent } from 'vue'
interface TravRating {
        rating: number
        colorNumber: number
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TravRating',
  props: {
    rating: null,
    colorNumber: null
  },
  setup(__props: any) {

    

return { __sfc: true, }
}

})